$('.menu-toggle').click(function() {
    $('.navigation-responsive').toggleClass('nav-active');
    $('.menu-toggle').toggleClass('toggle-open');
    $('.bar').toggleClass('open');
});


